import { render, staticRenderFns } from "./Form17ProcessHeader.vue?vue&type=template&id=6c9b0d3e&scoped=true"
import script from "./Form17ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form17ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form17ProcessHeader.vue?vue&type=style&index=0&id=6c9b0d3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9b0d3e",
  null
  
)

export default component.exports